import React, { useState, useEffect } from "react";
import "../Styles/Studentapprove.css";
import { useNavigate } from "react-router-dom";

import {
  FaFilter,
  FaSearch,
  FaEnvelope,
  FaTrash,
} from "react-icons/fa";

import { IoLogoWhatsapp } from "react-icons/io";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import ApiService from "../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

function Studentapprove() {

  const navigate = useNavigate();

  const [students, setStudents] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");

  const [selectedIds, setSelectedIds] = useState([]);

  const [page, setPage] = useState(1);

  const [loading, setLoading] = useState(false);

  const [sendOptions, setSendOptions] = useState({
    email: false,
    whatsapp: false,
  });

  const recordsPerPage = 10;

  /* =========================================
     FETCH STUDENTS
  ========================================= */
  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {

    try {

      setLoading(true);

      const res = await AdminAPI.getStudents();

      console.log("FULL API RESPONSE:", res);

      console.log("API DATA:", res.data);

      const list = Array.isArray(res.data)
        ? res.data
        : res.data?.data || [];

      console.log("STUDENT LIST:", list);

      const formatted = list.map((stu, index) => {

        console.log("SINGLE STUDENT:", stu);

        return {

          /* =========================================
             IMPORTANT
             USE MEMBERSHIP ID
          ========================================= */
          id:
            stu?.member?.membership_id ||
            stu?.membership_id ||
            index,

          membership_id:
            stu?.member?.membership_id || "",

          member_id:
            stu?.details?.member_id || "",

          /* =========================================
             PERSONAL DETAILS
          ========================================= */
          name:
            stu?.member?.full_name || "",

          email:
            stu?.member?.email || "",

          phone:
            stu?.member?.mobile || "",

          gender:
            stu?.member?.gender || "",

          dob:
            stu?.member?.dob || "",

          blood_group:
            stu?.member?.blood_group || "",

          state:
            stu?.member?.state || "",

          district:
            stu?.member?.district || "",

          pincode:
            stu?.member?.pincode || "",

          role:
            stu?.member?.role || "",

          candidate_type:
            stu?.member?.candidate_type || "",

          profile_pic:
            stu?.member?.profile_pic || "",

          /* =========================================
             STATUS
          ========================================= */
          status:
            (
              stu?.member?.status ||
              stu?.status ||
              "pending"
            ).toLowerCase(),

          approved_at:
            stu?.member?.approved_at || "",

          rejected_at:
            stu?.member?.rejected_at || "",

          created_at:
            stu?.member?.created_at || "",

          whatsapp_notification:
            stu?.member?.whatsapp_notification || false,

          /* =========================================
             STUDENT DETAILS
          ========================================= */
          qualification:
            stu?.details?.qualification || "",

          university_name:
            stu?.details?.university_name || "",

          college_name:
            stu?.details?.college_name || "",

          college_code:
            stu?.details?.college_code || "",

          department:
            stu?.details?.department || "",

          start_year:
            stu?.details?.start_year || "",

          end_year:
            stu?.details?.end_year || "",

          location:
            stu?.details?.location || "",

          student_email:
            stu?.details?.email || "",

          id_front:
            stu?.details?.id_front || "",

          id_back:
            stu?.details?.id_back || "",

          raw: stu,
        };
      });

      console.log("FORMATTED STUDENTS:", formatted);

      setStudents(formatted);

    } catch (err) {

      console.error("FETCH ERROR:", err);

      if (err.response) {

        console.log("ERROR RESPONSE:", err.response);

        console.log("ERROR DATA:", err.response.data);
      }

      toast.error("Failed to load students");

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     SEARCH
  ========================================= */
  const filtered = students.filter((s) => {

    const term = searchTerm.toLowerCase();

    return (

      s.name.toLowerCase().includes(term) ||

      s.qualification.toLowerCase().includes(term) ||

      s.phone.toLowerCase().includes(term) ||

      s.status.toLowerCase().includes(term) ||

      s.college_name.toLowerCase().includes(term) ||

      s.university_name.toLowerCase().includes(term)
    );
  });

  /* =========================================
     PAGINATION
  ========================================= */
  const paginated = filtered.slice(
    (page - 1) * recordsPerPage,
    page * recordsPerPage
  );

  const totalPages =
    Math.ceil(filtered.length / recordsPerPage) || 1;

  /* =========================================
     SELECT ALL
  ========================================= */
  const toggleSelectAll = (e) => {

    if (e.target.checked) {

      setSelectedIds(
        paginated.map(
          (s) => s.membership_id
        )
      );

    } else {

      setSelectedIds([]);
    }
  };

  /* =========================================
     SELECT SINGLE
  ========================================= */
  const toggleSelect = (membershipId) => {

    setSelectedIds((prev) =>

      prev.includes(membershipId)

        ? prev.filter((x) => x !== membershipId)

        : [...prev, membershipId]
    );
  };

  /* =========================================
     ALL SELECTED
  ========================================= */
  const isAllSelected =
    paginated.length > 0 &&
    paginated.every((s) =>
      selectedIds.includes(s.membership_id)
    );

  /* =========================================
     UPDATE STATUS UI
  ========================================= */
  const updateStatusUI = (
    membershipIds,
    newStatus
  ) => {

    setStudents((prev) =>
      prev.map((s) => {

        if (
          membershipIds.includes(
            s.membership_id
          )
        ) {

          return {
            ...s,
            status: newStatus,
          };
        }

        return s;
      })
    );
  };

  /* =========================================
     APPROVE
  ========================================= */
  const handleApprove = async () => {

    if (!selectedIds.length) {

      toast.warning("Select students");

      return;
    }

    try {

      setLoading(true);

      console.log(
        "APPROVE MEMBERSHIP IDS =>",
        selectedIds
      );

      /* =========================================
         API CALL
      ========================================= */
      await Promise.all(
        selectedIds.map((membershipId) =>
          AdminAPI.approveMember(
            membershipId
          )
        )
      );

      /* =========================================
         UPDATE TABLE UI
      ========================================= */
      updateStatusUI(
        selectedIds,
        "approved"
      );

      toast.success(
        "Approved successfully!"
      );

      setSelectedIds([]);

    } catch (err) {

      console.error(
        "APPROVE ERROR =>",
        err
      );

      toast.error("Approval failed");

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     REJECT
  ========================================= */
  const handleReject = async () => {

    if (!selectedIds.length) {

      toast.warning("Select students");

      return;
    }

    try {

      setLoading(true);

      console.log(
        "REJECT MEMBERSHIP IDS =>",
        selectedIds
      );

      /* =========================================
         API CALL
      ========================================= */
      await Promise.all(
        selectedIds.map((membershipId) =>
          AdminAPI.rejectMember(
            membershipId
          )
        )
      );

      /* =========================================
         UPDATE TABLE UI
      ========================================= */
      updateStatusUI(
        selectedIds,
        "rejected"
      );

      toast.success(
        "Rejected successfully!"
      );

      setSelectedIds([]);

    } catch (err) {

      console.error(
        "REJECT ERROR =>",
        err
      );

      toast.error("Reject failed");

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     DELETE SELECTED
  ========================================= */
  const handleDeleteSelected = async () => {

    if (!selectedIds.length) {

      toast.warning("Select students");

      return;
    }

    try {

      setLoading(true);

      await Promise.all(
        selectedIds.map((membershipId) =>
          AdminAPI.deleteMember(
            membershipId
          )
        )
      );

      setStudents((prev) =>
        prev.filter(
          (s) =>
            !selectedIds.includes(
              s.membership_id
            )
        )
      );

      toast.success(
        "Deleted successfully!"
      );

      setSelectedIds([]);

    } catch (err) {

      console.error(err);

      toast.error("Delete failed");

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     DELETE ALL
  ========================================= */
  const handleDeleteAll = async () => {

    try {

      const allIds = students.map(
        (s) => s.membership_id
      );

      if (!allIds.length) {

        toast.warning(
          "No students found"
        );

        return;
      }

      setLoading(true);

      await Promise.all(
        allIds.map((membershipId) =>
          AdminAPI.deleteMember(
            membershipId
          )
        )
      );

      setStudents([]);

      setSelectedIds([]);

      toast.success("All deleted!");

    } catch (err) {

      console.error(err);

      toast.error("Delete all failed");

    } finally {

      setLoading(false);
    }
  };

  /* =========================================
     SEND MESSAGE
  ========================================= */
  const handleSendMessages = () => {

    if (!selectedIds.length) {

      toast.warning("Select students");

      return;
    }

    const channels = [];

    if (sendOptions.email)
      channels.push("Email");

    if (sendOptions.whatsapp)
      channels.push("WhatsApp");

    if (!channels.length) {

      toast.warning(
        "Select Email or WhatsApp"
      );

      return;
    }

    toast.success(
      `Message sent via ${channels.join(", ")}`
    );
  };

  return (

    <div className="empview-container">

      <ToastContainer
        position="top-center"
        autoClose={2000}
      />

      {/* =========================================
         HEADER
      ========================================= */}
      <div className="empview-header-bar">

        <h2>Student Approval</h2>

      </div>

      {/* =========================================
         ACTION BAR
      ========================================= */}
      <div className="empview-action-bar">

        <button className="empview-filter-btn">
          <FaFilter /> Filter
        </button>

        <div className="empview-search-box">

          <FaSearch />

          <input
            type="text"
            placeholder="Search students..."
            value={searchTerm}
            onChange={(e) =>
              setSearchTerm(
                e.target.value
              )
            }
          />

        </div>

        <button
          onClick={handleDeleteAll}
          className="empview-delete-btn"
        >
          <FaTrash /> Delete All
        </button>

      </div>

      {/* =========================================
         TOOLBAR
      ========================================= */}
      <div className="empview-toolbar">

        <label>
          {students.length} Students
        </label>

        <label>

          <input
            type="checkbox"
            checked={sendOptions.email}
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                email: !p.email,
              }))
            }
          />

          <FaEnvelope /> Email

        </label>

        <label>

          <input
            type="checkbox"
            checked={sendOptions.whatsapp}
            onChange={() =>
              setSendOptions((p) => ({
                ...p,
                whatsapp: !p.whatsapp,
              }))
            }
          />

          <IoLogoWhatsapp /> WhatsApp

        </label>

        <button
          onClick={handleSendMessages}
          className="empview-send-btn"
        >
          Send
        </button>

        <button
          onClick={handleApprove}
          className="empview-download-btn"
          disabled={loading}
        >
          Approve
        </button>

        <button
          onClick={handleReject}
          className="empview-download-btn"
          disabled={loading}
        >
          Reject
        </button>

        <button
          onClick={handleDeleteSelected}
          className="empview-delete-btn"
          disabled={loading}
        >
          Delete Selected
        </button>

      </div>

      {/* =========================================
         TABLE
      ========================================= */}
      <div className="empview-table-container">

        <table className="empview-table table table-hover">

          <thead>

            <tr>

              <th>

                <input
                  type="checkbox"
                  checked={isAllSelected}
                  onChange={toggleSelectAll}
                />

              </th>

              <th>Name</th>

              <th>Qualification</th>

              <th>Phone</th>

              <th>Status</th>

              <th>Action</th>

            </tr>

          </thead>

          <tbody>

            {paginated.length > 0 ? (

              paginated.map((s) => (

                <tr key={s.membership_id}>

                  <td>

                    <input
                      type="checkbox"
                      checked={selectedIds.includes(
                        s.membership_id
                      )}
                      onChange={() =>
                        toggleSelect(
                          s.membership_id
                        )
                      }
                    />

                  </td>

                  <td>{s.name}</td>

                  <td>{s.qualification}</td>

                  <td>{s.phone}</td>

                  <td
                    style={{
                      fontWeight: "bold",

                      color:
                        s.status === "approved"
                          ? "green"
                          : s.status ===
                            "rejected"
                          ? "red"
                          : "orange",
                    }}
                  >
                    {s.status}
                  </td>

                  <td>

                    <button
                      className="empview-view-btn"
                      onClick={() =>
                        navigate(
                          "/dashboard/StudentapproveView",
                          {
                            state: {
                              membershipId:
                                s.membership_id,

                              studentData: s,
                            },
                          }
                        )
                      }
                    >
                      View
                    </button>

                  </td>

                </tr>
              ))

            ) : (

              <tr>

                <td
                  colSpan="6"
                  className="text-center"
                >
                  No records found
                </td>

              </tr>
            )}

          </tbody>

        </table>

      </div>

      {/* =========================================
         PAGINATION
      ========================================= */}
      <div className="empview-pagination">

        <button
          disabled={page === 1}
          onClick={() =>
            setPage(page - 1)
          }
        >
          Prev
        </button>

        <span>
          Page {page} of {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() =>
            setPage(page + 1)
          }
        >
          Next
        </button>

      </div>

    </div>
  );
}

export default Studentapprove;